import React from 'react'

//html select substitution
function Selection({arr, label, handleChange, selected}) {
  return (
    <div>
        <label htmlFor={label}></label>
        <select name={`${label}`} id={`${label}`}  onChange={handleChange} style={{padding:'0.2rem 0rem'}}>
            <option value="#">Select</option>
            { arr && arr.map((op, index) => <option key={label + index} selected={op[0] === selected} value={op[0]}>{op[1]}</option>)}
        </select>
    </div>
  )
}

export default Selection